import { render, staticRenderFns } from "./multipleLimit-editor.vue?vue&type=template&id=353638e8&scoped=true&"
import script from "./multipleLimit-editor.vue?vue&type=script&lang=js&"
export * from "./multipleLimit-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353638e8",
  null
  
)

export default component.exports